/* COMMON */
export const COMMON_REQUEST = 'COMMON_REQUEST';
export const COMMON_SUCCESS = 'COMMON_SUCCESS';
export const COMMON_FAILED = 'COMMON_FAILED';
export const COUNTRY_REQUEST = 'COUNTRY_REQUEST';
export const COUNTRY_SUCCESS = 'COUNTRY_SUCCESS';
export const COUNTRY_FAILED = 'COUNTRY_FAILED';
export const PROVINCE_REQUEST = 'PROVINCE_REQUEST';
export const PROVINCE_SUCCESS = 'PROVINCE_SUCCESS';
export const PROVINCE_FAILED = 'PROVINCE_FAILED';
export const CITY_REQUEST = 'CITY_REQUEST';
export const CITY_SUCCESS = 'CITY_SUCCESS';
export const CITY_FAILED = 'CITY_FAILED';
export const CARD_GENERATE = 'CARD_GENERATE';
export const CARD_GENERATE_SUCCESS = 'CARD_GENERATE_SUCCESS';
export const CARD_GENERATE_FAILED = 'CARD_GENERATE_FAILED';
export const COMPANY_REQUEST = 'COMPANY_REQUEST';
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS';
export const COMPANY_FAILED = 'COMPANY_FAILED';
export const AUTONOMY_REQUEST = 'AUTONOMY_REQUEST';
export const AUTONOMY_SUCCESS = 'AUTONOMY_SUCCESS';
export const AUTONOMY_FAILED = 'AUTONOMY_FAILED';
export const FAQ_CATEGORY_REQUEST = 'FAQ_CATEGORY_REQUEST';
export const FAQ_CATEGORY_SUCCESS = 'FAQ_CATEGORY_SUCCESS';
export const FAQ_CATEGORY_FAILED = 'FAQ_CATEGORY_FAILED';
export const MODALITY_CATEGORY_REQUEST = 'MODALITY_CATEGORY_REQUEST';
export const MODALITY_CATEGORY_SUCCESS = 'MODALITY_CATEGORY_SUCCESS';
export const MODALITY_CATEGORY_FAILED = 'MODALITY_CATEGORY_FAILED';
export const ADMIN_HISTORIC_REQUEST = 'ADMIN_HISTORIC_REQUEST';
export const ADMIN_HISTORIC_SUCCESS = 'ADMIN_HISTORIC_SUCCESS';
export const ADMIN_HISTORIC_FAILED = 'ADMIN_HISTORIC_FAILED';

export const CARD_PIN_REQUEST = 'CARD_PIN_REQUEST';
export const CARD_PIN_REQUEST_SUCCESS = 'CARD_PIN_REQUEST_SUCCESS';
export const CARD_PIN_REQUEST_FAILED = 'CARD_PIN_REQUEST_FAILED';
export const CARD_CVV_REQUEST = 'CARD_CVV_REQUEST';
export const CARD_CVV_REQUEST_SUCCESS = 'CARD_CVV_REQUEST_SUCCESS';
export const CARD_CVV_REQUEST_FAILED = 'CARD_CVV_REQUEST_FAILED';
export const CARD_CVV_REQUEST_CLEAR = 'CARD_CVV_REQUEST_CLEAR';
export const CARD_PAN_REQUEST = 'CARD_PAN_REQUEST';
export const CARD_PAN_REQUEST_SUCCESS = 'CARD_PAN_REQUEST_SUCCESS';
export const CARD_PAN_REQUEST_FAILED = 'CARD_PAN_REQUEST_FAILED';
export const CARD_PAN_REQUEST_CLEAR = 'CARD_PAN_REQUEST_CLEAR';
export const CARD_CODE_REQUEST = 'CARD_CODE_REQUEST';
export const CARD_CODE_REQUEST_SUCCESS = 'CARD_CODE_REQUEST_SUCCESS';
export const CARD_CODE_REQUEST_FAILED = 'CARD_CODE_REQUEST_FAILED';
export const CARD_CODE_REQUEST_CLEAR = 'CARD_CODE_REQUEST_CLEAR';
export const CARD_CODE_MODIFY = 'CARD_CODE_MODIFY';
export const CARD_CODE_MODIFY_SUCCESS = 'CARD_CODE_MODIFY_SUCCESS';
export const CARD_CODE_MODIFY_FAILED = 'CARD_CODE_MODIFY_FAILED';
export const CARD_CODE_MODIFY_CLEAR = 'CARD_CODE_MODIFY_CLEAR';
export const CARD_CONFIRMATION_REQUEST = 'CARD_CONFIRMATION_REQUEST';
export const CARD_CONFIRMATION_REQUEST_SUCCESS = 'CARD_CONFIRMATION_REQUEST_SUCCESS';
export const CARD_CONFIRMATION_REQUEST_FAILED = 'CARD_CONFIRMATION_REQUEST_FAILED';
export const CARD_CONFIRMATION_REQUEST_CLEAR = 'CARD_CONFIRMATION_REQUEST_CLEAR';
export const CARD_STATUS_REQUEST = 'CARD_STATUS_REQUEST';
export const CARD_STATUS_REQUEST_SUCCESS = 'CARD_STATUS_REQUEST_SUCCESS';
export const CARD_STATUS_REQUEST_FAILED = 'CARD_STATUS_REQUEST_FAILED';
export const CARD_TOGGLE = 'CARD_TOGGLE';
export const CARD_TOGGLE_SUCCESS = 'CARD_TOGGLE_SUCCESS';
export const CARD_TOGGLE_FAILED = 'CARD_TOGGLE_FAILED';
export const CARD_TOGGLE_CLEAR = 'CARD_TOGGLE_CLEAR';
export const CARD_TRANSACTIONS = 'CARD_TRANSACTIONS';
export const CARD_TRANSACTIONS_SUCCESS = 'CARD_TRANSACTIONS_SUCCESS';
export const CARD_TRANSACTIONS_FAILED = 'CARD_TRANSACTIONS_FAILED';
export const CARD_RECHARGE = 'CARD_RECHARGE';
export const CARD_RECHARGE_SUCCESS = 'CARD_RECHARGE_SUCCESS';
export const CARD_RECHARGE_FAILED = 'CARD_RECHARGE_FAILED';
export const CARD_RECHARGE_NOTIFICATION = 'CARD_RECHARGE_NOTIFICATION';
export const CARD_RECHARGE_NOTIFICATION_SUCCESS = 'CARD_RECHARGE_NOTIFICATION_SUCCESS';
export const CARD_RECHARGE_NOTIFICATION_FAILED = 'CARD_RECHARGE_NOTIFICATION_FAILED';
export const CARD_BALANCE = 'CARD_BALANCE';
export const CARD_BALANCE_SUCCESS = 'CARD_BALANCE_SUCCESS';
export const CARD_BALANCE_FAILED = 'CARD_BALANCE_FAILED';
export const CARD_BALANCE_RETURN = 'CARD_BALANCE_RETURN';
export const CARD_BALANCE_RETURN_SUCCESS = 'CARD_BALANCE_RETURN_SUCCESS';
export const CARD_BALANCE_RETURN_FAILED = 'CARD_BALANCE_RETURN_FAILED';
export const CARD_PHONE = 'CARD_PHONE';
export const CARD_PHONE_SUCCESS = 'CARD_PHONE_SUCCESS';
export const CARD_PHONE_FAILED = 'CARD_PHONE_FAILED';
export const CARD_PHONE_CLEAR = 'CARD_PHONE_CLEAR';
export const CARD_PERSONAL = 'CARD_PERSONAL';
export const CARD_PERSONAL_SUCCESS = 'CARD_PERSONAL_SUCCESS';
export const CARD_PERSONAL_FAILED = 'CARD_PERSONAL_FAILED';
export const CARD_PERSONAL_CLEAR = 'CARD_PERSONAL_CLEAR';

export const CANCEL_SELECTION_REQUEST = 'CANCEL_SELECTION_REQUEST';
export const CANCEL_SELECTION_SUCCESS = 'CANCEL_SELECTION_SUCCESS';
export const CANCEL_SELECTION_FAILED = 'CANCEL_SELECTION_FAILED';

export const CANCEL_INSURANCE_REQUEST = 'CANCEL_INSURANCE_REQUEST';
export const CANCEL_INSURANCE_SUCCESS = 'CANCEL_INSURANCE_SUCCESS';
export const CANCEL_INSURANCE_FAILED = 'CANCEL_INSURANCE_FAILED';

export const CARD_SINGLE_GENERATE = 'CARD_SINGLE_GENERATE';
export const CARD_SINGLE_GENERATE_SUCCESS = 'CARD_SINGLE_GENERATE_SUCCESS';
export const CARD_SINGLE_GENERATE_FAILED = 'CARD_SINGLE_GENERATE_FAILED';
export const CARD_SINGLE_RECHARGE = 'CARD_SINGLE_RECHARGE';
export const CARD_SINGLE_RECHARGE_SUCCESS = 'CARD_SINGLE_RECHARGE_SUCCESS';
export const CARD_SINGLE_RECHARGE_FAILED = 'CARD_SINGLE_RECHARGE_FAILED';
export const CARD_SINGLE_NOTIFICATION = 'CARD_SINGLE_NOTIFICATION';
export const CARD_SINGLE_NOTIFICATION_SUCCESS = 'CARD_SINGLE_NOTIFICATION_SUCCESS';
export const CARD_SINGLE_NOTIFICATION_FAILED = 'CARD_SINGLE_NOTIFICATION_FAILED';
